import Navbar from "./Navbar";
import Footer from "./Footer";
import CartDrawer from "./CartDrawer";
import BannerStrip from "@/components/shared/BannerStrip";
import { useCart } from "@/lib/cartStore";

export default function Layout({ children }) {
    const cart = useCart();
    return (
        <div className="min-h-screen flex flex-col bg-background text-foreground">
            <Navbar cart={cart} />
            <BannerStrip scope="home" />
            <main className="flex-1">{children}</main>
            <Footer />
            <CartDrawer cart={cart} />
        </div>
    );
}
